var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFbShare = function SvgFbShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.675 0H1.325A1.326 1.326 0 0 0 0 1.325v21.35A1.326 1.326 0 0 0 1.325 24H12v-9.5H9.131V11H12V8.413a4.56 4.56 0 0 1 4.919-4.788c1.325 0 2.75.1 3.081.144v3.238h-2.206C16.288 7.007 16 7.72 16 8.77V11h3.588l-.469 3.5H16V24h6.675A1.326 1.326 0 0 0 24 22.675V1.325A1.326 1.326 0 0 0 22.675 0"
  })));
};
export default SvgFbShare;